import { cn } from '@/lib/utils';
import React from 'react';
interface SectionTagProps {
  children: React.ReactNode;
  className?: string;
  /** `dark` para usarlo sobre las bandas carbón. */
  tone?: 'light' | 'dark';
}
export function SectionTag({
  children,
  className = '',
  tone = 'light'
}: SectionTagProps) {
  return <span className={cn('inline-flex items-center gap-2 text-[0.6rem] font-bold uppercase tracking-editorial sm:text-[0.66rem]', tone === 'dark' ? 'text-gold-soft' : 'text-gold-deep', className)} data-id="element-225" data-mp="25qiz55a93rj6">
      <span className={cn('h-px w-6', tone === 'dark' ? 'bg-gold-soft/60' : 'bg-gold/70')} aria-hidden data-id="element-226" data-mp="2fmcip8me0lag" />
      {children}
    </span>;
}